function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import ActionTypes from '../../../ActionsTypes';
import InitialState from './initialState';
var initialState = new InitialState();
export var UPDATING_USER = 'UPDATING_USER';
export var ERROR_UPDATING_USER = 'ERROR_UPDATING_USER';
export var SELECT_PREMIUM_PRODUCT = 'SELECT_PREMIUM_PRODUCT';
var STATE_DEFAULT = {
  firstName: '',
  lastName: '',
  email: '',
  institutionName: '',
  institutionType: '',
  productForQuoteRequest: ''
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ActionTypes.SAVE_USER_ROLE:
      return _objectSpread({}, state, {
        user: _objectSpread({}, state.user, {
          role: action.payload.userRole,
          authenticated: true
        })
      });

    case ActionTypes.CLEAR_USER_ROLE:
      return {};

    case ActionTypes.UPDATING_USER:
      return _objectSpread({}, state, {
        user: _objectSpread({}, state.user, {
          firstName: action.user.first_name,
          lastName: action.user.last_name,
          email: action.user.email,
          institutionName: action.user.institution_name,
          institutionType: action.user.institution_type
        })
      });

    case ActionTypes.ERROR_UPDATING_USER:
      return _objectSpread({}, state, {
        user: STATE_DEFAULT
      });

    case ActionTypes.SELECT_PREMIUM_PRODUCT:
      return _objectSpread({}, state, {
        user: {
          productForQuoteRequest: action.product
        }
      });

    default:
      return state;
  }
});